import axios from "axios";
import { baseurl_node } from "../config";

const axiosClient = axios.create({
  baseURL: baseurl_node,
});

export default axiosClient;